import React, { Component } from "react"
import PropTypes from "prop-types"

class Editor extends Component {
  componentDidMount() {
    const { blocks, editorRef } = this.props
    editorRef.isReady
      .then(() => editorRef.clear())
      .then(() => editorRef.render({ blocks }))
  }

  render() {
    const { outstanding, reject, accept } = this.props

    return (
      outstanding && (
        <span className="profile-buttons">
          <div className="margin-auto mb-2">
            <button
              data-testid="tc-accept-button"
              type="button"
              className="profile-button-style mr-2"
              onClick={accept}
            >
              ACCEPT
            </button>
            <button
              data-testid="tc-reject-button"
              type="button"
              className="profile-button-hollow ml-2"
              onClick={reject}
            >
              REJECT
            </button>
          </div>
        </span>
      )
    )
  }
}

Editor.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  outstanding: PropTypes.bool.isRequired,
  accept: PropTypes.func.isRequired,
  editorRef: PropTypes.shape({
    clear: PropTypes.func,
    isReady: PropTypes.shape({
      then: PropTypes.func,
    }),
    render: PropTypes.func.isRequired,
  }).isRequired,
  reject: PropTypes.func.isRequired,
}

export default Editor
